import '../header.css'

function Credit() {
    return (
    <div id='credits'>
        <p>EUROPEAN CHEMICAL MANUFACTURER</p>
        <p>BREST, FRANCE</p>
        <p>SINCE 1995</p>
    </div>
    )
}

export default Credit
